<template>
    <div
        class="list-pagination d-flex flex-column flex-sm-row align-center justify-space-between ga-4"
    >
        <div class="d-flex align-center flex-wrap ga-3">
            <span v-if="totalItems > 0" class="text-body-2 text-medium-emphasis">{{
                rangeLabel
            }}</span>
            <v-select
                :model-value="itemsPerPage"
                :items="itemsPerPageOptions"
                :label="$t('pagination.itemsPerPage')"
                density="compact"
                hide-details
                class="list-pagination__page-size"
                @update:model-value="$emit('update:itemsPerPage', $event)"
            >
                <template #selection>
                    <span class="d-flex justify-center w-100">{{ itemsPerPage }}</span>
                </template>
                <template #item="{ props, item }">
                    <v-list-item v-bind="props" :title="null">
                        <v-list-item-title class="text-center">{{ item.title }}</v-list-item-title>
                    </v-list-item>
                </template>
            </v-select>
        </div>

        <div class="d-flex align-center flex-shrink-0">
            <v-pagination
                v-if="totalItems > 0 && pageCount > 1"
                :model-value="page"
                :length="pageCount"
                :total-visible="totalVisible"
                color="primary"
                density="comfortable"
                rounded="lg"
                @update:model-value="$emit('update:page', $event)"
            />
            <!-- Leaves room for the global language FAB (bottom-right, ~56px + gap). -->
            <div
                v-if="clearAppFab"
                class="flex-shrink-0"
                style="width: 70px"
                aria-hidden="true"
            />
        </div>
    </div>
</template>

<script>
export default {
    name: "ListPagination",
    props: {
        page: {
            type: Number,
            required: true,
        },
        itemsPerPage: {
            type: Number,
            required: true,
        },
        totalItems: {
            type: Number,
            required: true,
        },
        itemsPerPageOptions: {
            type: Array,
            default: () => [10, 50, 100],
        },
        /** Extra end space so controls are not covered by App.vue LanguageSelector FAB. */
        clearAppFab: {
            type: Boolean,
            default: false,
        },
    },
    emits: ["update:page", "update:itemsPerPage"],
    computed: {
        pageCount() {
            return Math.max(1, Math.ceil(this.totalItems / this.itemsPerPage));
        },
        rangeLabel() {
            const start = (this.page - 1) * this.itemsPerPage + 1;
            const end = Math.min(this.page * this.itemsPerPage, this.totalItems);
            return this.$t("pagination.range", {
                start,
                end,
                total: this.totalItems,
            });
        },
        totalVisible() {
            return this.$vuetify?.display?.smAndDown ? 5 : 7;
        },
    },
};
</script>

<style scoped>
.list-pagination__page-size {
    max-width: 120px;
    min-width: 100px;
}
</style>
